import axios, { AxiosResponse } from 'axios';

// POST
// Save strain for real or harvested fishgroup.
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/{fishGroupId}/strain
export const postFishGroupStrain = async (
  globalSiteId: string,
  fishGroupId: string,
  seaCloudStrainId: number
): Promise<AxiosResponse> => {
  return await axios.post<AxiosResponse>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/${fishGroupId}/strain`, {
    seaCloudStrainId,
  });
};
